/* eslint-disable react/prop-types */
import React from 'react';
import styled from 'styled-components';

import { SmallButton } from '../../styles/ui/Button';

// Estilos (idênticos ao de permissões)
const PdvsGrid = styled.div`
   display: grid;
   grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
   gap: 12px;
   margin-top: 16px;
`;

const PdvCard = styled.label`
   display: flex;
   align-items: center;
   gap: 10px;
   padding: 12px;
   border: 1px solid #ddd;
   border-radius: 6px;
   cursor: pointer;
   transition: all 0.2s;

   &:hover {
      background-color: #f5f5f5;
      border-color: #999;
   }

   input[type='checkbox'] {
      cursor: pointer;
   }
`;

const PdvInfo = styled.div`
   flex: 1;
   display: flex;
   flex-direction: column;
   gap: 4px;
`;

const PdvName = styled.div`
   font-weight: 600;
   font-size: 14px;
   color: #333;
`;

const PdvId = styled.div`
   font-size: 11px;
   color: #999;
   font-family: monospace;
`;

const SelectAllButton = styled(SmallButton)`
   margin-bottom: 12px;
`;

/**
 * Componente para selecionar PDVs do usuário
 * 
 * @param {Array} allPdvs - Lista de todos os PDVs disponíveis
 * @param {Array} selectedPdvIds - IDs dos PDVs selecionados
 * @param {Function} onChange - Callback quando seleção muda
 * @param {Boolean} disabled - Se está desabilitado
 */
export default function PdvSelector({
   allPdvs = [],
   selectedPdvIds = [],
   onChange,
   disabled = false,
}) {
   const handleTogglePdv = (pdvId) => {
      if (disabled) return;

      if (selectedPdvIds.includes(pdvId)) {
         // Remove
         onChange(selectedPdvIds.filter((id) => id !== pdvId));
      } else {
         // Adiciona
         onChange([...selectedPdvIds, pdvId]);
      }
   };

   const handleToggleAll = () => {
      if (disabled) return;

      if (selectedPdvIds.length === allPdvs.length) {
         // Desmarcar todos
         onChange([]);
      } else {
         // Marcar todos
         onChange(allPdvs.map((p) => p.id));
      }
   };

   const allSelected = selectedPdvIds.length === allPdvs.length;

   if (allPdvs.length === 0) {
      return (
         <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
            <p>Nenhum PDV disponível no sistema.</p>
         </div>
      );
   }

   return (
      <>
         <SelectAllButton
            type="button"
            onClick={handleToggleAll}
            disabled={disabled}
         >
            {allSelected ? '✓ Desmarcar todos' : 'Marcar todos'}
         </SelectAllButton>

         <div
            style={{
               marginBottom: '8px',
               fontSize: '13px',
               color: '#666',
            }}
         >
            {selectedPdvIds.length} de {allPdvs.length} PDVs selecionados
         </div>

         <PdvsGrid>
            {allPdvs.map((pdv) => (
               <PdvCard key={pdv.id}>
                  <input
                     type="checkbox"
                     checked={selectedPdvIds.includes(pdv.id)}
                     onChange={() => handleTogglePdv(pdv.id)}
                     disabled={disabled}
                  />
                  <PdvInfo>
                     <PdvName>{pdv.pdv_name || pdv.name}</PdvName>
                     <PdvId>ID: {pdv.id}</PdvId>
                  </PdvInfo>
               </PdvCard>
            ))}
         </PdvsGrid>
      </>
   );
}
